(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('chart-export-file', {
                parent: 'entity',
                url: '/chart-export-file/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'ChartExportFiles'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart-export-file/list/chart-export-files.html',
                        controller: 'ChartExportFileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['ChartExport', '$stateParams', function (ChartExport, $stateParams) {
                        return ChartExport.get({id: $stateParams.id}).$promise;
                    }]
                }
            });
    }
})();
